import React, { useState } from 'react'

function IconLinkedin({ width = 20, height = 20, styles = { bgColor: '#C0C0C0' } }) {
    const [hover, setHover] = useState(false)

    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <g clipPath='url(#clip0_198_571)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M3.45238 0.833496C2.75776 0.833496 2.0916 1.10943 1.60043 1.6006C1.10926 2.09176 0.833328 2.75793 0.833328 3.45254V16.5478C0.833328 17.2424 1.10926 17.9086 1.60043 18.3997C2.0916 18.8909 2.75776 19.1668 3.45238 19.1668H16.5476C17.2422 19.1668 17.9084 18.8909 18.3996 18.3997C18.8907 17.9086 19.1667 17.2424 19.1667 16.5478V3.45254C19.1667 2.75793 18.8907 2.09176 18.3996 1.6006C17.9084 1.10943 17.2422 0.833496 16.5476 0.833496H3.45238ZM4.89547 6.46052C5.3105 6.46052 5.70854 6.29565 6.00201 6.00218C6.29548 5.7087 6.46035 5.31067 6.46035 4.89564C6.46035 4.48061 6.29548 4.08257 6.00201 3.7891C5.70854 3.49563 5.3105 3.33076 4.89547 3.33076C4.48044 3.33076 4.08241 3.49563 3.78893 3.7891C3.49546 4.08257 3.33059 4.48061 3.33059 4.89564C3.33059 5.31067 3.49546 5.7087 3.78893 6.00218C4.08241 6.29565 4.48044 6.46052 4.89547 6.46052ZM6.205 16.3029V7.68754H3.58595V16.3029H6.205ZM7.94404 7.68754H10.5631V8.84123C10.9494 8.23623 11.798 7.42171 13.3759 7.42171C15.259 7.42171 16.2818 8.66969 16.2818 11.0439C16.2818 11.1578 16.2923 11.6777 16.2923 11.6777V16.3016H13.6732V11.679C13.6732 11.0439 13.5396 9.79588 12.128 9.79588C10.715 9.79588 10.5958 11.3647 10.5631 12.3914V16.3016H7.94404V7.68754Z'
                    fill={hover ? '#0A66C2' : styles.bgColor}
                    style={{
                        opacity: hover ? 0 : 1,
                        transition: 'opacity .3s ease'
                    }}
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M3.45238 0.833496C2.75776 0.833496 2.0916 1.10943 1.60043 1.6006C1.10926 2.09176 0.833328 2.75793 0.833328 3.45254V16.5478C0.833328 17.2424 1.10926 17.9086 1.60043 18.3997C2.0916 18.8909 2.75776 19.1668 3.45238 19.1668H16.5476C17.2422 19.1668 17.9084 18.8909 18.3996 18.3997C18.8907 17.9086 19.1667 17.2424 19.1667 16.5478V3.45254C19.1667 2.75793 18.8907 2.09176 18.3996 1.6006C17.9084 1.10943 17.2422 0.833496 16.5476 0.833496H3.45238ZM4.89547 6.46052C5.3105 6.46052 5.70854 6.29565 6.00201 6.00218C6.29548 5.7087 6.46035 5.31067 6.46035 4.89564C6.46035 4.48061 6.29548 4.08257 6.00201 3.7891C5.70854 3.49563 5.3105 3.33076 4.89547 3.33076C4.48044 3.33076 4.08241 3.49563 3.78893 3.7891C3.49546 4.08257 3.33059 4.48061 3.33059 4.89564C3.33059 5.31067 3.49546 5.7087 3.78893 6.00218C4.08241 6.29565 4.48044 6.46052 4.89547 6.46052ZM6.205 16.3029V7.68754H3.58595V16.3029H6.205ZM7.94404 7.68754H10.5631V8.84123C10.9494 8.23623 11.798 7.42171 13.3759 7.42171C15.259 7.42171 16.2818 8.66969 16.2818 11.0439C16.2818 11.1578 16.2923 11.6777 16.2923 11.6777V16.3016H13.6732V11.679C13.6732 11.0439 13.5396 9.79588 12.128 9.79588C10.715 9.79588 10.5958 11.3647 10.5631 12.3914V16.3016H7.94404V7.68754Z'
                    fill={hover ? '#0A66C2' : styles.bgColor}
                    style={{
                        opacity: hover ? 1 : 0,
                        transition: 'opacity .3s ease'
                    }}
                />
            </g>
            <defs>
                <clipPath id='clip0_198_571'>
                    <rect width='20' height='20' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IconLinkedin
